module.exports = __webpack_public_path__ + "img/onboarding4.148e072e.png";